import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';

export default class CollectionsCarousel {
	constructor(el) {
		this.element 			= el
		this.background			= el.querySelector('.block-collections-carousel__bg')
		this.backgrounds		= el.querySelectorAll('.block-collections-carousel__bg img')
		this.previousSlide		= 0
		this.progressTimeline	= el.querySelector('.block-carousel__progress')
		this.playInterval		= 6000

		this.changeBackground = this.changeBackground.bind(this)		

		this.CollectionsSwiper = new Swiper( this.element, {
			loop: true,
			parallax: true,
			slideToClickedSlide: true,
			centeredSlides: true,
			slidesPerView: 'auto',
			grabCursor:	true,
			autoplay: {
				delay: this.playInterval,
			},
			speed: 1500,
			allowTouchMove: true,
			initialSlide: 1,
			preventInteractionOnTransition: true,
			normalizeIndex: true,
			on: {
				init: (()=>{
					if(this.progressTimeline){
						this.progressTimeline.classList.add('active')
					}
				})
			}
		});

		// UPDATE BACKGROUND ON SLIDE CHANGE
		this.CollectionsSwiper && this.CollectionsSwiper.on( 'realIndexChange', (swiper) =>
		{
			this.changeBackground(swiper.realIndex, swiper.previousIndex)
		});

		// CREATE TIMER
		this.progressTimeline && this.CollectionsSwiper.on( 'slideChangeTransitionStart', (swiper) =>
		{
			this.progressTimeline.classList.remove('active')
			void this.progressTimeline.offsetWidth; // This forces reflow and restart animatino
			this.progressTimeline.classList.add('active')
		});

	}
  
	changeBackground(activeIndex, previousIndex) {
		// console.log(`previous slide:${this.previousSlide}`)
		// console.log(`activeSlide:${activeIndex}`)

		this.backgrounds.forEach((bg)=>{
			bg.style.opacity = '0';
			bg.style.transform = 'scale(1.1)';
			bg.style.zIndex = '0';
		})

		this.backgrounds[activeIndex].style.opacity = '1';
		this.backgrounds[activeIndex].style.transform = 'scale(1)';
		this.backgrounds[activeIndex].style.zIndex = '6';

		// if(!this.previousSlide == activeIndex){
		// 	this.backgrounds[this.previousSlide].style.opacity = '0';
		// 	this.backgrounds[this.previousSlide].style.transform = 'scale(1.1)';
		// 	this.backgrounds[this.previousSlide].style.zIndex = '0';
		// }

		this.previousSlide = activeIndex;
	}

}
